import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { ManpowerDetailsTransporter } from "./manpowerDetailsTransporter";
import { authKey, ResourceUpdateMember, GET_CONFIG_BY_SERVICE_TYPE } from '../../../../common/URLs';
import "react-datepicker/dist/react-datepicker.css";
import { VehiclePopverDetails } from "./vehiclePopoverDetails";
import IconButton from '@mui/material/IconButton';
import { BANK_STATEMENT, DATE_RANGE_ERROR, EMPTY_FIELD_ERROR, GST, UPLOAD_FILE_TEXT } from "../../../../common/constants";
import { API_DATE_FORMAT, BASIC_DATE_FORMAT, LOI_ABRPL_AGREEMENT, ROLES } from '../../../../common/constants';
import moment from 'moment';
import { loaderService } from "../../../../common/custom-loader/loader-service";
import { Autocomplete, Chip, Button, Switch, Container, Divider, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { checkDateValidation, openTextFieldMaxLength, VALIDATION } from "../../../../common/commonValidations";
import Preview from '../../registration/preview';
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { PROD } from "../../../../common/constants";
import { QuickSearchToolbar } from "../../../../payment/common/commonFunctions";
import { DataGrid, GridEditInputCell, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { VehicleValidation } from '../../../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import BackButton from "../../../../common/backButton";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { ConfirmationPopover } from "../../../../common/commonPopovers/confirmationPopover";
import { useTransporterContextData } from "./registrationDetailsTransporter";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { insertComment } from '../commonRegistrationStakeholderAPIs';
import jwt from 'jwt-decode';
import Badge from 'react-bootstrap/Badge';
import { EditIcon, SaveIcon } from "../../../../common/icons";
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, emailUrnPassMaxLength, mobileNoMaxLength, approverCommentMaxLength, govtIDcardLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength} from '../../../../common/commonValidations';
import apiClient from "../../../../axios";
import CommentIcon from '@mui/icons-material/Comment';




const VehicleDetailsTransporter = () => {
    const { viewOnly, transporterDetails, documentArray, details, setDocumentArray, totalManpower, setTotalManpower, dataFromDriverPopover, setDataFromDriverPopover, dataFromVehiclePopover, setDataFromVehiclePopover, agreementStartDate, agreementStartDisplay, agreementEndDate, agreementEndDisplay, setVehicleCount, totalVehicleCount, gstNumber, setGstNumber, selectedArea, setSelectedArea, vehicleDataDisplay, setVehicleDataDisplay, selectedAreaApi, setSelectedAreaApi, setAgreementStartDate, setAgreementEndDate, setAgreementStartDisplay, setAgreementEndDisplay, agreementDetailsSectionOk, setAgreementDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, shouldActOnSection, showCommentSection, setCommentsData, comments, enableFieldFunction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, vehicleDetailsSectionOk, setVehicleDetailsSectionOk, regScruResourceUpdate, setRegScruResourceUpdate } = useTransporterContextData();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const uuid = localStorage.getItem('uuid');
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [areaOfOperationsArr, setAreaOfOperationsArr] = useState([]);
    const [driverDataReload, setDriverDataReload] = useState();
    const [vehicleDataReload, setVehicleDataReload] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    let agreementComments = comments?.filter((item) => item.sectionName === "agreement_details");
    let vehicleComments = comments?.filter((item) => item.sectionName === "vehicle_details");
    const [characterLimit] = useState(300);
    const [agreementComment, setAgreementComment] = useState("");
    const [vehicleComment, setVehicleComment] = useState("");
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleConfirmLogModalClose = () => setLogModalOpen(false);
    const [logModalOpenVehicle, setLogModalOpenVehicle] = useState(false);
    const handleLogModalOpenVehicle = () => setLogModalOpenVehicle(true);
    const handleLogModalCloseVehicle = () => setLogModalOpenVehicle(false);
    const [logModalOpenDriver, setLogModalOpenDriver] = useState(false);
    const handleLogModalOpenDriver = () => setLogModalOpenDriver(true);
    const handleLogModalCloseDriver = () => setLogModalOpenDriver(false);
    let userRole = localStorage.getItem('role');

    useEffect(() => {
        getAreasOfOperation();
    }, []);

    const getAreasOfOperation = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONFIG_BY_SERVICE_TYPE,
                {
                    "serviceType": "Transporter"
                },
                {
                    headers: {
                        AuthKey: authKey,
                    }
                }, null
            )
            .then((response) => {
                // setAreaOfOperationsArr(response.data.configs);
                let filteredData = response.data.configs.filter(item => item.appKey === 'AreaOfOperation');
                let data = filteredData[0].value.split(',')
                setAreaOfOperationsArr(data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        setTotalManpower(dataFromDriverPopover?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length);
        setVehicleCount(dataFromVehiclePopover?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length);
    }, [dataFromDriverPopover, dataFromVehiclePopover]);

    const getData = (dataToBePassed) => {
        let arrayData = [...dataFromVehiclePopover];
        arrayData.push(dataToBePassed);
        setVehicleData(arrayData)

    }
    const onAgreementStartDateChange = (e) => {
        // let selectedDate = e.target.value
        // let formattedDate = moment(selectedDate).format(API_DATE_FORMAT)
        setAgreementStartDisplay(e.format(BASIC_DATE_FORMAT))
        setAgreementStartDate(e.format(API_DATE_FORMAT))
        if (checkDateValidation(e.format("YYYY-MM-DD"), agreementEndDisplay)) {
            setErrorMessage({ ...errorMessage, agreementDateError: DATE_RANGE_ERROR })
        } else setErrorMessage({ ...errorMessage, agreementDateError: '' })
    }

    const onAgreementEndDateChange = (e) => {
        // let selectedDate = e.target.value
        // let formattedDate = moment(selectedDate).format(API_DATE_FORMAT)
        setAgreementEndDisplay(e.format(BASIC_DATE_FORMAT))
        setAgreementEndDate(e.format(API_DATE_FORMAT))
        if (checkDateValidation(agreementStartDisplay, e.format("YYYY-MM-DD"))) {
            setErrorMessage({ ...errorMessage, agreementDateError: DATE_RANGE_ERROR })
        } else setErrorMessage({ ...errorMessage, agreementDateError: '' })

    }
    const getEditedData = (dataToBePassed) => {
        const newState = dataFromVehiclePopover.map(obj => {
            if (obj.id === dataToBePassed.id) {
                return {
                    "id": dataToBePassed?.id,
                    "regTransporterMasterId": dataToBePassed?.regTransporterMasterId,
                    "vehicleType": dataToBePassed.vehicleType,
                    "grossVehicleWeight": dataToBePassed.grossVehicleWeight,
                    "unladenWeight": dataToBePassed.unladenWeight,
                    "vehicleMake": dataToBePassed.vehicleMake,
                    "vehicleModel": dataToBePassed.vehicleModel,
                    "vehicleAge": dataToBePassed.vehicleAge,
                    "insuranceNo": dataToBePassed.insuranceNo,
                    "insuranceEnddate": dataToBePassed.insuranceEnddate,
                    "registrationEndDate": dataToBePassed.registrationEndDate,
                    "puccNo": dataToBePassed.puccNo,
                    "puccEndDate": dataToBePassed.puccEndDate,
                    "fitnessNo": dataToBePassed.fitnessNo,
                    "fitnessEndDate": dataToBePassed.fitnessEndDate,
                    "isNationalPermitAvailable": dataToBePassed.isNationalPermitAvailable,
                    "nationalPermitEnddate": dataToBePassed.nationalPermitEnddate,
                    "ownershipType": dataToBePassed.ownershipType,
                    "registrationNo": dataToBePassed.registrationNo,
                    "isActive": 1,
                    "documents": dataToBePassed.documents
                }
            }
            return obj;
        });
        setVehicleData(newState)

    }
    const setVehicleData = (arrayData) => {
        setDataFromVehiclePopover(arrayData);
        setVehicleDataReload(arrayData);
        setVehicleCount(arrayData.length);
    }
    const [selectedTypeVehicle, setSelectedTypeVehicle] = useState("");
    const [selectedVehicle, setSelectedVehicle] = useState("");
    const [selectedTypeDriver, setSelectedTypeDriver] = useState("");
    const [selectedDriver, setSelectedDriver] = useState("");
    const addEditVehicleDetailsClick = (e, selected, type) => {
        e.preventDefault(selected);
        setSelectedVehicle(selected);
        setSelectedTypeVehicle(type);
        handleLogModalOpenVehicle();
    }
    const getManpowerData = (dataToBePassed) => {
        let arrayData = [...dataFromDriverPopover];
        arrayData.push(dataToBePassed);
        setManpowerData(arrayData);
    }

    const getEditedManpowerData = (dataToBePassed) => {
        const newState = dataFromDriverPopover.map(obj => {
            if (obj.id === dataToBePassed.id) {
                return {
                    "id": dataToBePassed.id,
                    "regTransporterMasterId": dataToBePassed.regTransporterMasterId,
                    "driverName": dataToBePassed.driverName,
                    "driverAge": dataToBePassed.driverAge,
                    "driverGender": dataToBePassed.driverGender,
                    "driverContactNo": dataToBePassed.driverContactNo,
                    "driverAddress": dataToBePassed.driverAddress,
                    "driverPincode": dataToBePassed.driverPincode,
                    "yearsOfExp": dataToBePassed.yearsOfExp,
                    "agreementStartDate": dataToBePassed.agreementStartDate,
                    "agreementEndDate": dataToBePassed.agreementEndDate,
                    "driverType": "string",
                    "driverLicenseId": dataToBePassed.driverLicenseId,
                    "isActive": 1,
                    "createdOn": "2022-09-30T11:51:23.894Z",
                    "createdBy": "string",
                    "updatedOn": "2022-09-30T11:51:23.894Z",
                    "updatedBy": "string",
                    "documents": dataToBePassed.documents
                }
            }
            return obj;
        });
        setManpowerData(newState)

    }
    const setManpowerData = (arr) => {
        setDataFromDriverPopover(arr);
        setDriverDataReload(arr);
        setTotalManpower(dataFromDriverPopover?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length);

    }
    const addEditManpowerDetailsClick = (e, selected, type) => {
        e.preventDefault(selected);
        setSelectedDriver(selected);
        setSelectedTypeDriver(type);
        handleLogModalOpenDriver();
    }
    const onTotalManpowerChange = (e) => {
        e.preventDefault();
        setTotalManpower(e.target.value);
    }
    const onDeleteVehicle = (e, selected) => {
        e.preventDefault();
        const updatedArr = ((dataFromVehiclePopover).map(item => {
            if (item.id === selected) {
                item.isActive = 0
            }
            return item
        }
        ))
        setDataFromVehiclePopover(updatedArr);

    }
    const onDeleteDriver = (e, selected) => {
        e.preventDefault();
        const updatedArr = ((dataFromDriverPopover).map(item => {
            if (item.id === selected) {
                item.isActive = 0
            }
            return item
        }
        ))
        setDataFromDriverPopover(updatedArr);
    }
    const onGstNumberChange = (e) => {
        e.preventDefault();
        setGstNumber(e.target.value.toUpperCase());
        if (gstNumber && gstNumber.length > 0 && VALIDATION.gstNumberValidation(e.target.value)) {
            setErrorMessage({ ...errorMessage, gstNumberError: '' })
            setGstNumber(e.target.value.toUpperCase());
        } else setErrorMessage({ ...errorMessage, gstNumberError: 'Gst number invalid' })
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
    }

    const OnAddAreaOfOperation = (e, value) => {
        setSelectedArea(value);
        // e.preventDefault();
        // setAddAreaOfOperation(true);
        // const temp = dataFromPersonalDetails?.transporterMasters[0]?.existingAreaOfOperation?.split(",")
        // setSelectedArea([
        //     ...temp,
        //     ...value.filter((option) => temp.indexOf(option) === -1),
        // ]);
    }
    const temparr = selectedAreaApi;
    const handleAreaChange = (e) => {
        let value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setSelectedArea(value);
        setErrorMessage({ ...errorMessage, areaErr: '' })
    }


    useEffect(() => {
        if (selectedArea) {
            var combinedata = selectedAreaApi.toString() + "," + selectedArea.toString();
            //var x = Array.from(new Set(combinedata.split(','))).toString()
            setSelectedAreaApi(Array.from(new Set(combinedata.split(','))).toString());
            // let value = Array.from(
            //     selectedArea
            // );
        }
    }, [selectedArea]);

    const driverCol = [
        { field: 'driverName', headerName: t('reg.fullName'), width: 150 },
        // { field: 'yearsOfExp', headerName: t('reg.experience'), width: 90 },
        { field: 'driverLicenseId', headerName: t('reg.licenseNo'), width: 150 },
        {
            field: t('reg.actions'), width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="Edit"><IconButton color="primary" onClick={(e) => addEditManpowerDetailsClick(e, params.row.id, "edit")} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)}><EditIcon /></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton color={!enableFieldFunction(shouldActOnSection.vehicle_details, false) ? 'disabled' : 'error'} onClick={(e) => onDeleteDriver(e, params.row.id)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} component="label">
                            <DeleteIcon />
                        </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ];

    // console.log("vehicleDataDisplay", vehicleDataDisplay)


    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

    function EditInputCell(props) {
        const { error, id, value: valueProp, field } = props;
        const [value, setValue] = useState(valueProp);
        const apiRef = useGridApiContext();

        const handleChange = (event) => {
            const newValue = event.target.value;
            apiRef.current.setEditCellValue({ id, field, value: newValue });
            setValue(newValue);
        };

        useEffect(() => {
            setValue(valueProp);
        }, [valueProp]);

        return (
            <StyledTooltip open={!!error} title={error}>
                <GridEditInputCell {...props} value={value} onChange={handleChange} />
            </StyledTooltip>
        );
    }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }

    const columns = [
        {
            field: 'vehicleType',
            headerName: t('preReg.vehicleType'),
            width: 120
        },
        {
            field: 'ownedVehicles',
            headerName: t('preReg.ownedVehicle'),
            width: 175,
            type: "number",
            editable: enableFieldFunction(shouldActOnSection.vehicle_details, false),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: VehicleValidation(params.props.value, 5, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'rentedVehicles',
            headerName: t('preReg.rentedVehicle'),
            width: 175,
            type: "number",
            editable: enableFieldFunction(shouldActOnSection.vehicle_details, false),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: VehicleValidation(params.props.value, 5, 2) };
            },
            renderEditCell: renderEdit,
        },
    ]

    const processRowUpdate = (newRow) => {
        vehicleDataDisplay.forEach((item) => {
            if (item.vehicleType === newRow.vehicleType) {
                item.ownedVehicles = newRow.ownedVehicles
                item.rentedVehicles = newRow.rentedVehicles
            }
        })
        // setErrorMessgae({ ...errorMessage, noOfVehicleError: '' })
        return newRow
    };


    const onSaveComment = (comment, sectionName, sectionOk) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: transporterDetails?.transporterMasters[0]?.regStakeholderMasterId,
            sectionName: sectionName,
            sectionId: transporterDetails?.transporterMasters[0]?.id,
            sectionOk: sectionOk,
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid,
        }
        comment ? insertComment([commentObject], transporterDetails?.transporterMasters[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
        setAgreementComment("");
        setVehicleComment("");
        setErrorMessage({ ...errorMessage, agreementCommentError: "", vehicleCommentError: "" });
    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const vehicleCol = [
        { field: 'vehicleType', headerName: t('preReg.vehicleType'), width: 150 },
        { field: 'registrationNo', headerName: t('reg.registrationNo'), width: 150 },
        {
            field: 'grossVehicleWeight', headerName: t('reg.grossWeightinKg'), width: 150,
            valueGetter: (params) => {
                return params.row.grossVehicleWeight + ' ' + "Kg"
            }
        },
        {
            field: 'vehicleCapacity', headerName: t('reg.vehicleCapacityinKg'), width: 170,
            valueGetter: (params) => {
                return params.row.grossVehicleWeight - params.row.unladenWeight + ' ' + "Kg"
            }
        },
        { field: 'ownershipType', headerName: t('reg.ownership'), width: 150 },
        {
            field: t('reg.actions'), width: 150,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="Edit"><IconButton color="primary" onClick={(e) => addEditVehicleDetailsClick(e, params.row.id, 'edit')} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)}><EditIcon /></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton color={!enableFieldFunction(shouldActOnSection.vehicle_details, false) ? 'disabled' : 'error'} onClick={(e) => onDeleteVehicle(e, params.row.id)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} component="label">
                            <DeleteIcon />
                        </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ];

    return (
        <>
            {transporterDetails && <>
                <Grid item xs={12}>
                    <Accordion mt={1} expanded={expandedSection === "agreement"}
                        onChange={(event, expanded) => {
                            setExpandedSection(expanded ? "agreement" : "");
                        }}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                            <Stack ml={2} display="flex" alignItems="center" direction="row">
                                {showCommentSection && !regScruResourceUpdate && (agreementDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                <Typography variant="subtitle1">{t('preReg.licenseAgreementDetails')}</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                <Grid item xs={6} lg={3}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                inputFormat="DD/MM/YYYY"
                                                label={t('reg.startDate')}
                                                value={agreementStartDisplay}
                                                name="agreementStartDate"
                                                onChange={(e) => onAgreementStartDateChange(e)}
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                renderInput={(params) => <TextField {...params} />}
                                                sx={{ minWidth: 750 }} />
                                        </LocalizationProvider>
                                        <FormHelperText>{errorMessage.agreementDateError}</FormHelperText>
                                    </FormControl>
                                    <FileUploadMUI key={LOI_ABRPL_AGREEMENT}
                                        documentList={documentArray}
                                        documentType={LOI_ABRPL_AGREEMENT}
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={transporterDetails?.transporterMasters[0]?.id}
                                        title={t('reg.uploadLOI&AgreementDoc')}
                                        stakeholderType="Transporter"
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="agreementDocError"
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.agreementDocError}</div> */}
                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                inputFormat="DD/MM/YYYY"
                                                label={t('reg.endDate')}
                                                minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                value={agreementEndDisplay}
                                                onChange={(e) => onAgreementEndDateChange(e)}
                                                name="agreementEndDate"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                renderInput={(params) => <TextField {...params} />}
                                                sx={{ minWidth: 750 }}
                                            />
                                        </LocalizationProvider>
                                        <FormHelperText>{errorMessage.agreementDateError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth error={errorMessage.gstNumberError} helperText={errorMessage.gstNumberError} disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)} type="text" label={t('preReg.gstNo')} name="gstNumber" value={gstNumber || ''} onChange={(e) => onGstNumberChange(e)} inputProps={{
                                        maxLength: 15
                                    }} />
                                    <FileUploadMUI key={GST}
                                        documentList={documentArray}
                                        documentType={GST}
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={transporterDetails?.transporterMasters[0]?.id}
                                        title={t('preReg.uploadGst')}
                                        stakeholderType="Transporter"
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="gstDocError"
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.gstDocError}</div> */}
                                </Grid>
                            </Grid>
                            {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                <Grid item xs={7}> <TextField sx={{ width: "100%" }}
                                    label={t('reg.comment')}
                                    helperText={errorMessage.agreementCommentError}
                                    error={errorMessage.agreementCommentError}
                                    name="comment"
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    multiline
                                    disabled={!shouldActOnSection.agreement_details || viewOnly}
                                    value={agreementComment}
                                    onChange={(e) => setAgreementComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                />
                                <BadgeComponent currentLength={details?.plotComment?.length} maxLength={approverCommentMaxLength} />
                                    {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                        <Badge bg={`${agreementComment?.length > characterLimit ? 'danger' : 'primary'}`}>{agreementComment?.length}/{characterLimit}</Badge>
                                    </div> */}
                                </Grid><Grid item xs={2}>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.agreement_details || viewOnly} checked={agreementDetailsSectionOk}
                                            onChange={(e) => setAgreementDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                {t('reg.detailsOk')}?
                                            </Typography>} />
                                    </FormGroup>
                                </Grid><Grid item xs={3}>
                                    <Button variant="contained" disabled={!shouldActOnSection.agreement_details || viewOnly}
                                        onClick={() => onSaveComment(agreementComment, "agreement_details", agreementDetailsSectionOk)}
                                        startIcon={<CommentIcon />}
                                    >
                                        {t('preReg.addComment')}
                                    </Button>
                                </Grid>
                            </Grid>
                                <div>
                                    <Accordion mt={1} >
                                        <AccordionSummary
                                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                        >
                                            <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box style={{ height: 300, width: '100%' }}>
                                                <DataGrid
                                                    rows={agreementComments ? agreementComments : []}
                                                    columns={commentsColumn}
                                                    pageSize={10}
                                                    getRowHeight={() => 'auto'} />
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </div></>}
                        </AccordionDetails>

                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion mt={1} expanded={expandedSection === "vehicle"}
                        onChange={(event, expanded) => {
                            setExpandedSection(expanded ? "vehicle" : "");
                        }}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (vehicleDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                            <Stack ml={2} display="flex" alignItems="center" direction="row">
                                {showCommentSection && !regScruResourceUpdate && (vehicleDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                <Typography variant="subtitle1">Vehicle & Manpower Details</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (vehicleDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                <Grid item xs={6} lg={3}>
                                    <TextField fullWidth label={t('reg.totalVehicleCount')} disabled type="text" name="totalVehicleCount" value={totalVehicleCount} onChange={(e) => onTotalManpowerChange(e)} inputProps={{
                                        maxLength: 10
                                    }} />
                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <TextField fullWidth label={t('reg.totalManpower')} disabled type="text" name="totalManpower" value={totalManpower} onChange={(e) => onTotalManpowerChange(e)} inputProps={{
                                        maxLength: 10
                                    }} />

                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <Autocomplete
                                        multiple
                                        // disabled={isDisabled()}
                                        // disabled={isAdminEnable()}
                                        // disableCloseOnSelect={true}
                                        options={areaOfOperationsArr}
                                        value={selectedArea}
                                        onChange={(e, value) => OnAddAreaOfOperation(e, value)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                error={errorMessage.areaErr}
                                                helperText={errorMessage.areaErr}
                                                required
                                                label={t('reg.areasOfOperation')}
                                                disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)}
                                            />
                                        )}
                                    // renderTags={(tagValue, getTagProps) =>
                                    //     tagValue.map((option, index) => (
                                    //         <Chip
                                    //             label={option}
                                    //             {...getTagProps({ index })}
                                    //             disabled={dataFromPersonalDetails?.transporterMasters[0]?.existingAreaOfOperation?.split(",").indexOf(option) !== -1}
                                    //         />
                                    //     ))
                                    // }
                                    />
                                </Grid>
                                <Grid item xs={12} lg={7}>
                                    <Box mb={2} sx={{
                                        '& .super-app-theme--header': {
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-all',
                                            whiteSpace: 'initial',
                                        },
                                        '& .MuiDataGrid-cell--editable': {
                                            bgcolor: (theme) =>
                                                theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                        },
                                        '& .super-app.confirmationStatusPending': {
                                            backgroundColor: '#FFFF8F',
                                            color: '#1a3e72',
                                            fontWeight: '600',
                                        },
                                        '& .super-app.confirmationStatusRejected': {
                                            backgroundColor: '#F88379',
                                            color: '#1a3e72',
                                            fontWeight: '600',
                                        },
                                        '& .super-app.confirmationStatusConfirmed': {
                                            backgroundColor: '#ECFFDC',
                                            color: 'green',
                                            fontWeight: '600',
                                        },
                                        '& .Mui-error': {
                                            backgroundColor: `rgb(126,10,15,0.1)`,
                                            color: (theme) => theme.palette.error.main,
                                        },
                                    }}>

                                        <DataGrid
                                            autoHeight
                                            rows={vehicleDataDisplay}
                                            pagination={false}
                                            hideFooterPagination
                                            columns={columns}
                                            getRowId={(row) => row.vehicleType}
                                            disableColumnMenu={true}
                                            experimentalFeatures={{ newEditingApi: true }}
                                            processRowUpdate={(e) => processRowUpdate(e)}
                                        // onCellEditStop={(params, event) => {
                                        //     if (params.reason === GridCellEditStopReasons.cellFocusOut) {
                                        //         event.defaultMuiPrevented = true;
                                        //     } onCellEditStop(params, event)
                                        // }}
                                        />

                                    </Box>
                                </Grid>
                                <Grid item xs={12} lg={6} mt={2} >
                                    <div className='mandatory_field'>{errorMessage.manpowerVechicletableError}</div>
                                    <Typography variant="h6" gutterBottom>
                                        {t('reg.driverDetails')}
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                                        <Button onClick={(e) => addEditManpowerDetailsClick(e, transporterDetails?.transporterDetail?.id, 'add')} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} variant="contained" startIcon={<AddIcon />}>
                                            {t('reg.addDriverDetails')}
                                        </Button>
                                    </Stack>
                                    <Box style={{ height: 'auto', width: '100%' }}>
                                        <DataGrid
                                            autoHeight
                                            getRowHeight={() => 'auto'}
                                            rows={dataFromDriverPopover.filter((item1) => (item1.isActive === 1 || item1.isActive === 3))}
                                            columns={driverCol}
                                            pageSize={10}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} lg={6} mt={2} >
                                    <Typography variant="h6" gutterBottom>
                                        {t('reg.vehicleDetails')}
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                                        <Button onClick={(e) => addEditVehicleDetailsClick(e, transporterDetails?.transporterDetail?.id, 'add')} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} variant="contained" startIcon={<AddIcon />}>
                                            {t('reg.addVehicleDetails')}
                                        </Button>
                                    </Stack>
                                    <Box style={{ height: 'auto', width: '100%' }}>
                                        <DataGrid
                                            autoHeight
                                            getRowHeight={() => 'auto'}
                                            rows={dataFromVehiclePopover.filter((item1) => (item1.isActive === 1 || item1.isActive === 3))}
                                            columns={vehicleCol}
                                            pageSize={10}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                <Grid item xs={7}> <TextField sx={{ width: "100%" }}
                                    label={t('reg.comment')}
                                    helperText={errorMessage.vehicleCommentError}
                                    error={errorMessage.vehicleCommentError}
                                    name="comment"
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    multiline
                                    disabled={!shouldActOnSection.vehicle_details || viewOnly}
                                    value={vehicleComment}
                                    onChange={(e) => setVehicleComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                /><div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                        <Badge bg={`${vehicleComment?.length > characterLimit ? 'danger' : 'primary'}`}>{vehicleComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.vehicle_details || viewOnly} checked={vehicleDetailsSectionOk}
                                            onChange={(e) => setVehicleDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                {t('reg.detailsOk')}?
                                            </Typography>} />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={3}>
                                    <Button variant="contained" disabled={!shouldActOnSection.vehicle_details || viewOnly}
                                        onClick={() => onSaveComment(vehicleComment, "vehicle_details", vehicleDetailsSectionOk)}
                                        startIcon={<CommentIcon />}
                                    >
                                        {t('preReg.addComment')}
                                    </Button>
                                </Grid>
                            </Grid>
                                <div>
                                    <Accordion mt={1} >
                                        <AccordionSummary
                                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                        >
                                            <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box style={{ height: 300, width: '100%' }}>
                                                <DataGrid
                                                    rows={vehicleComments ? vehicleComments : []}
                                                    columns={commentsColumn}
                                                    pageSize={10}
                                                    getRowHeight={() => 'auto'} />
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </div></>}
                        </AccordionDetails>

                    </Accordion>
                </Grid> </>}
            <Dialog maxWidth='md' fullWidth open={logModalOpenVehicle}>
                <DialogContent>
                    <VehiclePopverDetails
                        onClose={handleLogModalCloseVehicle}
                        onSubmit={selectedTypeVehicle === 'add' ? getData : getEditedData}
                        data={selectedTypeVehicle === 'add' ? {} : dataFromVehiclePopover.filter((item) => item.id === selectedVehicle)[0]}
                        regID={transporterDetails?.transporterMasters[0]?.id}
                        regStakeholderMaster={transporterDetails?.transporterMasters[0]}
                        actionType={selectedTypeVehicle}
                        vehicleDataReload={vehicleDataReload}
                    />
                </DialogContent>
            </Dialog>
            <Dialog maxWidth='md' fullWidth open={logModalOpenDriver}>
                <DialogContent>
                    <ManpowerDetailsTransporter
                        onClose={handleLogModalCloseDriver}
                        onSubmit={selectedTypeDriver === 'add' ? getManpowerData : getEditedManpowerData}
                        data={selectedTypeDriver === 'add' ? {} : dataFromDriverPopover?.filter((item) => item.id === selectedDriver)[0]}
                        regStakeholderMaster={transporterDetails?.transporterMasters[0]}
                        regID={transporterDetails?.transporterMasters[0]?.id}
                        actionType={selectedTypeDriver}
                        driverDataReload={driverDataReload}
                    />
                </DialogContent>
            </Dialog>
        </>
    )

}
export default VehicleDetailsTransporter;

